// src/utils/sleep.js
//
// Simulates a wait function.

const sleep = async (seconds) => {
  return new Promise((res) => setTimeout(res, seconds * 1000));
};

export default sleep;
